<template>
  <v-card>
    <v-row>
      <v-col cols="4">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
         label="Allow Users to Change Penalty?" v-model="editItem.changePenalty" />
      </v-col>
      <v-col cols="4">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
         v-model="editItem.allowPartialPayemnts" label="Allow Partial Payments on Back Taxes" />
      </v-col>
      <v-col cols="4">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
        v-model="editItem.preFillPaymentWithOwnerName" label="Pre-fill 'Paid by' with owner name" />
      </v-col>
      <v-col cols="4" class="mt-n8">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
        v-model="editItem.warnWhenPayingRecWithMtg"
        label="Warn user when paying record with Mtg Code" />
      </v-col>
      <v-col cols="4" class="mt-n8">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
        v-model="editItem.removeMtgCodesOnImportedPayments"
        label="Auto-remove Mtg Codes on imported payments (Web/Lockbox)" />
      </v-col>
      <v-col cols="2" class="mt-n8">
        <v-text-field class="input-text-size pa-0" dense
          v-model="editItem.removeMtgCodesRangeFrom"
          :disabled="!editItem.removeMtgCodesOnImportedPayments"
          :rules="mtgCodeRangeRules"
          label="Mtg Code range from" />
      </v-col>
      <v-col cols="2" class="mt-n8">
        <v-text-field class="input-text-size pa-0" dense
          v-model="editItem.removeMtgCodesRangeTo"
          :disabled="!editItem.removeMtgCodesOnImportedPayments"
          :rules="mtgCodeRangeRules"
          label="Mtg Code range through" />
      </v-col>
      <v-col cols="4" class="mt-n8">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
        v-model="editItem.loadUnpaidsAutomatically" label="Load Unpaids Automatically" />
      </v-col>
      <v-col cols="4" class="mt-n8">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
        v-model="editItem.addAllUnpaidsToPickList" label="Add All Unpaids to Pick List"
        hint="When on, Add to List in Tax Inquiry also adds every unpaid year for the parcel. When off, only the records you select are added." persistent-hint />
      </v-col>
      <v-col cols="4" class="mt-n8">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
        v-model="editItem.onlyAdminsCanPostPayments" label="Only Admins Can Post Payments" />
      </v-col>
      <v-col cols="4" class="mt-n8">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
        v-model="editItem.abilityToAddMtgCodePayment"
        label="Ability to add mtg code upon payment" />
      </v-col>
      <v-col cols="4" class="mt-n8">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
        v-model="editItem.changeBussDateIndividually"
        label="Change Business Date Individually" />
      </v-col>
      <v-col cols="4" class="mt-n8">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
        v-model="editItem.autoSelectWkstOnPaymentReports"
        label="Auto select wkst on Payment Reports" />
      </v-col>
      <v-col cols="4" class="mt-n8">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
        v-model="editItem.decalNumberWhenDoingPayments"
        label="Prompt for Decal number on all MH payments" />
      </v-col>
      <v-col cols="4" class="mt-n8">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
        v-model="editItem.restrictWorkstationOverrideToTaxAdminsOnly"
        label="Restrict Workstation Override to Tax Administrators Only" />
      </v-col>
      <v-col cols="4" class="mt-n8">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
        v-model="editItem.auditsMustBeApprovedBeforePosting"
        label="Audits must be approved before posting" />
      </v-col>
       <v-col cols="4" class="mt-n8">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
        v-model="editItem.highlightCheckPaymentsWithNoImage"
        label="Highlight check payments with no image" />
      </v-col>
      <!-- <v-col cols="8" class="mt-n8"></v-col> -->
      <v-col cols="4" class="mt-n8">
        <ClarionDateControl class="input-text-size"
          :isToggle="false" v-model="editItem.latestPostDate"
          label="Latest Post Date" />
      </v-col>
      <v-col cols="4" class="mt-n8">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
          v-model="editItem.noPriorTax"
          label="No Prior Tax" />
      </v-col>
          <v-col cols="4" class="mt-n8">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
        v-model="editItem.allowEditCashTotalOnReconPage"
        label="Allow edit of totals on Recon page" />
      </v-col>
        <v-col cols="4" class="mt-n8">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
        v-model="editItem.preSortEnvelopes"
        label="Pre Sort Envelopes" />
      </v-col>
      <v-col cols="4" class="mt-n8">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
        v-model="editItem.defaultPaymentTypeCheck" label="Default payment type to 'Check'" />
      </v-col>
      <v-col cols="4" class="mt-n8">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
        v-model="editItem.defaultCursorToParcelID" label="Default cursor to Parcel ID" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4" class="pt-0 pb-0">
        <v-radio-group
          class="input-text-size"
          v-model="editItem.receiptReportPrint"
          row
          label="Receipts Report prints: "
        >
          <v-radio class="input-text-size" label="Paid By Name" value="paidByName"></v-radio>
          <v-radio class="input-text-size" label="Owner Name" value="ownerName"></v-radio>
        </v-radio-group>
      </v-col>
      <v-col cols="3" class="pt-0 pb-0">
        <SimpleMultiSelect
            id="tmc-payment-setting-exclude-wkst"
            label="Exclude Workstation"
            :items="editItem.excludeWkst"
            :item-list="wkstNumList"
            @selected-items="selectedWkstList"
          />
      </v-col>
      <v-col cols="1"></v-col>
       <v-col cols="4" class="pt-0 pb-0">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
        v-model="editItem.onlyAdminsCanEditTaxAmount"
        label="Only admins can edit tax amount being paid" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4" class="pt-0 pb-0">
        <v-radio-group
          class="input-text-size"
          v-model="editItem.defaultWkstOnCheckRecon"
          row
          label="Default wkst on check recon: "
        >
          <v-radio class="input-text-size" label="All" value="all"></v-radio>
          <v-radio class="input-text-size" label="Single" value="single"></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4" class="pt-0 pb-0">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
        v-model="editItem.allowChangeDueOnCheckPayments"
        label="Allow Change Due on check payments" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4" class="pt-0 pb-0">
      </v-col>
      <v-col cols="4" class="pt-0 pb-0">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
        v-model="editItem.showCertNumberOnPaymentScreen"
        label="Show Cert Number on Payment Screen"
        color="red"
        />
      </v-col>
      <v-col cols="4" class="pt-0 pb-0">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
        v-model="editItem.alternateOverpaymentHandling"
        label="Alternate Overpayment Handling"
        color="red"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4" class="pt-0 pb-0">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
        v-model="editItem.showReceiptNumberOnPaymentScreen"
        label="Show Receipt Number on Payment Screen"
        color="red"
        />
      </v-col>
      <v-col cols="4" class="pt-0 pb-0">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
        v-model="editItem.cannotApproveOwnAudit"
        label="Cannot Approve Own Audit"
        color="red"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4" class="pt-0 pb-0">
        <label class="input-text-size">Paid Receipts:</label>
      </v-col>
       <v-col cols="8" class="pt-0 pb-0">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
         label="Tax Amount Changes Create Audit" v-model="editItem.taxAmountChangesCreateAudit" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
         label="Print Legal Description on Paid Receipt" v-model="editItem.printLegalDescription" />
      </v-col>
       <v-col cols="3">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
         label="Cash only deposit slip" v-model="editItem.cashOnlyDepositSlip" />
      </v-col>
      <v-col cols="3">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
         label="Include Fee Details on Paid Receipt" v-model="editItem.includeFeeDetails" />
      </v-col>

      <v-col cols="3">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
         label="Separate Payment on Summary Report" v-model="editItem.sepratePaymentOnSummary" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="5" class="pt-0 pb-0">
        <div><h4>Email Settings:</h4></div>
        <v-text-field class="input-text-size pa-0" label="Bcc Email Address(Optional)"
         dense v-model="editItem.bccEmailAddress" />
        <v-text-field class="input-text-size pa-0" label="Subject Line"
         dense v-model="editItem.subjectLine" />
        <v-textarea class="input-text-size pa-0" label="Body"
         outlined rows="4" dense v-model="editItem.subjectBody" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0 pb-0">
        <label class="input-text-size">Forte Configuration:</label>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="2" class="">
        <label class="input-text-size font-weight-light">Web Payments</label>
      </v-col>
      <v-col cols="3" class="mt-n3">
        <v-text-field class="input-text-size pa-0" v-model="editItem.webApiAccessId"
         label="Forte API Access ID" required />
      </v-col>
      <v-col cols="3" class="mt-n3">
        <v-text-field class="input-text-size pa-0" v-model="editItem.webApiSecureId"
         label="Forte API Secure Key" required />
      </v-col>
      <v-col cols="3" class="mt-n3">
        <v-text-field class="input-text-size pa-0" v-model="editItem.webForteLocationId"
         label="Forte Location ID" required />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="2" class="">
        <label class="input-text-size font-weight-light">Point Of Sale</label>
      </v-col>
      <v-col cols="3" class="mt-n3">
        <v-text-field class="input-text-size pa-0" v-model="editItem.posApiAccessId"
         label="Forte API Access ID" required />
      </v-col>
      <v-col cols="3" class="mt-n3">
        <v-text-field class="input-text-size pa-0" v-model="editItem.posApiSecureId"
         label="Forte API Secure Key" required />
      </v-col>
      <v-col cols="3" class="mt-n3">
        <v-text-field class="input-text-size pa-0" v-model="editItem.posForteLocationId"
         label="Forte Location ID" required />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="2" class="">
        <label class="input-text-size font-weight-light">IVR</label>
      </v-col>
      <v-col cols="3" class="mt-n3">
      </v-col>
      <v-col cols="3" class="mt-n3">
      </v-col>
      <v-col cols="3" class="mt-n3">
        <v-text-field class="input-text-size pa-0" v-model="editItem.ivrForteLocationId"
         label="Forte Location ID" required />
      </v-col>
    </v-row>
    <!-- these are payrix credentials for TAX program only -->
     <v-row>
      <v-col cols="2">
        <label class="input-text-size font-weight-light">Convenience Fee Parameters</label>
      </v-col>
      <v-col cols="3" class="mt-n3">
        <v-text-field class="input-text-size pa-0" v-model="editItem.creditCardPercentage"
         label="Credit Card %" required />
      </v-col>
      <v-col cols="3" class="mt-n3">
        <v-text-field class="input-text-size pa-0" v-model="editItem.debitCardFee"
         label="Debit Card Fee" required />
      </v-col>
     </v-row>
    <v-row>
      <v-col cols="12" class="pt-0 pb-0">
        <label class="input-text-size">Payrix Configuration:</label>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="2" class="">
        <label class="input-text-size font-weight-light">Merchant IDs</label>
      </v-col>
      <v-col cols="3" class="mt-n3">
        <v-text-field class="input-text-size pa-0" v-model="editItem.posMerchantId"
         label="Payrix POS Merchant ID" required />
      </v-col>
      <v-col cols="3" class="mt-n3">
        <v-text-field class="input-text-size pa-0" v-model="editItem.webMerchantId"
         label="Payrix WEB Merchant ID" required />
      </v-col>
      <v-col cols="4" class="mt-n3">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
        v-model="editItem.autoMarkCreditCardsAsPaid"
        label="Automatically mark credit cards as paid" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="2" class="">
        <label class="input-text-size font-weight-light">Convenience Fee Parameters</label>
      </v-col>
      <v-col cols="2" class="mt-n3">
        <v-text-field class="input-text-size pa-0" v-model="editItem.payrixCreditPercentage"
         label="Payrix Credit Card %" required />
      </v-col>
      <v-col cols="2" class="mt-n3">
        <v-text-field class="input-text-size pa-0" v-model="editItem.payrixDebitPercentage"
         label="Payrix Debit Card %" required />
      </v-col>
      <v-col cols="2" class="mt-n3">
        <v-text-field class="input-text-size pa-0" v-model="editItem.payrixDebitAmtLimit"
         label="Payrix Debit Amount Limit" required />
      </v-col>
      <v-col cols="2" class="mt-n3">
        <v-text-field class="input-text-size pa-0" v-model="editItem.payrixDebitFeeFlat"
         label="Payrix Debit Fee (flat)" required />
      </v-col>
      <v-col cols="2" class="mt-n3">
        <v-text-field class="input-text-size pa-0" v-model="editItem.payrixEcheckFee"
         label="Payrix eCheck Fee (flat)" required />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="2" class="">
        <label class="input-text-size font-weight-light">URLs & Keys</label>
      </v-col>
      <v-col cols="2" class="mt-n3">
        <v-text-field class="input-text-size pa-0" v-model="editItem.jQueryCdnUrl"
         label="jQuery CDN URL" required />
      </v-col>
      <v-col cols="2" class="mt-n3">
        <v-text-field class="input-text-size pa-0" v-model="editItem.payrixCdnUrl"
         label="Payrix CDN URL" required />
      </v-col>
      <v-col cols="2" class="mt-n3">
        <v-text-field class="input-text-size pa-0" v-model="editItem.payrixBaseUrl"
         label="Payrix Base URL" required />
      </v-col>
      <v-col cols="2" class="mt-n3">
        <v-text-field class="input-text-size pa-0" v-model="editItem.payrixPublicKey"
         label="Payrix Public API Key" required />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="2" class="mt-n3">
        <!--empty column -->
      </v-col>
      <v-col cols="2" class="mt-n3">
        <v-text-field class="input-text-size pa-0" v-model="editItem.payrixPrivateKey"
         label="Payrix Private API Key" required />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="2" class="">
        <label class="input-text-size font-weight-light">Entity IDs</label>
      </v-col>
      <v-col cols="3" class="mt-n3">
        <v-text-field class="input-text-size pa-0" v-model="editItem.payrixPosEntityId"
        label="POS Entity ID" required />
      </v-col>
      <v-col cols="3" class="mt-n3">
        <v-text-field class="input-text-size pa-0" v-model="editItem.payrixWebEntityId"
        label="WEB Entity ID" required />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0 pb-0">
        <label class="input-text-size">Diagnostics:</label>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="2" class="">
        <label class="input-text-size font-weight-light">Troubleshooting</label>
      </v-col>
      <v-col cols="4" class="mt-n3">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
        v-model="editItem.paymentDiagnostics"
        label="Turn on payment diagnostics" />
      </v-col>
      <v-col cols="6" class="mt-n3">
        <label class="input-text-size font-weight-light">
          Records card reader and payment dialog activity in the background to help
          diagnose swipe problems. Does not change payments and does not change
          anything staff see. Leave off unless troubleshooting.
        </label>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0 pb-0">
        <label class="input-text-size">Forte2 Configuration:</label>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="2" class="">
        <label class="input-text-size font-weight-light">Forte.js</label>
      </v-col>
      <v-col cols="3" class="mt-n3">
        <v-text-field class="input-text-size pa-0" v-model="editItem.forte2ApiLoginId"
         label="Forte2 Forte.js API Login ID" required />
      </v-col>
      <v-col cols="3" class="mt-n3">
        <v-text-field class="input-text-size pa-0" v-model="editItem.forte2CdnUrl"
         label="Forte2 Forte.js CDN URL" required />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="2" class="">
        <label class="input-text-size font-weight-light">Convenience Fee Parameters</label>
      </v-col>
      <v-col cols="2" class="mt-n3">
        <v-text-field class="input-text-size pa-0" v-model="editItem.forte2CreditPercentage"
         label="Forte2 Credit %" required />
      </v-col>
      <v-col cols="2" class="mt-n3">
        <v-text-field class="input-text-size pa-0" v-model="editItem.forte2DebitPercentage"
         label="Forte2 Debit %" required />
      </v-col>
      <v-col cols="2" class="mt-n3">
        <v-text-field class="input-text-size pa-0" v-model="editItem.forte2EcheckFee"
         label="Forte2 eCheck Fee ($ flat)" required />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0 pb-0 mb-4">
        <label class="input-text-size">SMS Configuration:</label>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" class="mt-n3">
        <v-text-field class="input-text-size pa-0" v-model="editItem.baseUrlForSMS" label="Base url"
          required />
      </v-col>
      <v-col cols="3" class="mt-n3">
        <v-text-field class="input-text-size pa-0" v-model="editItem.countyNameForSMS"
         label="County Name" required />
      </v-col>
    </v-row>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn depressed color="primary" @click="update">
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import ClarionDateControl from '@/components/common/ClarionDateControl.vue';
import { mapActions, mapState } from 'vuex';
import { cloneItem } from '../../util/shared/vue-global';
import '../../assets/style.css';
import SimpleMultiSelect from '../common/base/SimpleMultiSelect.vue';

export default {
  components: {
    ClarionDateControl,
    SimpleMultiSelect,
  },
  data() {
    return {
      editItem: {
        excludeWkst: [],
      },
      originalPaymentSetting: null,
    };
  },
  async created() {
    await this.loadConfig({ requiredScope: 'paymentConfig' });
    await this.$nextTick();
    this.originalPaymentSetting = cloneItem(this.buildPaymentConfigItem());
    this.loadPaymentsWkstList();
  },
  computed: {
    // The backend silently skips auto-removal when either bound is missing or
    // non-numeric, so surface that here instead of letting a bad range save quietly.
    mtgCodeRangeRules() {
      if (!this.editItem.removeMtgCodesOnImportedPayments) return [];
      return [
        (v) => `${v || ''}`.trim() !== '' || 'Required when auto-remove is on',
        (v) => /^\d+$/.test(`${v || ''}`.trim()) || 'Numeric Mtg Code required',
      ];
    },
    ...mapState({
      paymentSettingItem: (state) => state.SystemConfig.paymentSettingItem || {},
      wkstNumList: (state) => state.tax.taxPayment.paymentWkstNumList || [],

    }),
  },
  watch: {
    paymentSettingItem: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.editItem = {
            ...newVal,
            excludeWkst: Array.isArray(newVal.excludeWkst) ? [...newVal.excludeWkst] : [],
            autoMarkCreditCardsAsPaid: newVal.autoMarkCreditCardsAsPaid !== false,
            paymentDiagnostics: newVal.paymentDiagnostics === true,
            addAllUnpaidsToPickList: newVal.addAllUnpaidsToPickList === true,
            defaultWkstOnCheckRecon: newVal.defaultWkstOnCheckRecon === 'all' ? 'all' : 'single',
          };
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapActions('SystemConfig', [
      'loadConfig', 'updateConfig',
    ]),
    ...mapActions('tax/taxPayment', [
      'loadPaymentsWkstList',
    ]),
    buildPaymentConfigItem() {
      const settingItem = this.editItem;
      /* When you will update any new field in the payment setting,
        you need to add the field here. */
      return {
        id: settingItem.id,
        changePenalty: settingItem.changePenalty,
        allowPartialPayemnts: settingItem.allowPartialPayemnts,
        preFillPaymentWithOwnerName: settingItem.preFillPaymentWithOwnerName,
        warnWhenPayingRecWithMtg: settingItem.warnWhenPayingRecWithMtg,
        removeMtgCodesOnImportedPayments: settingItem.removeMtgCodesOnImportedPayments,
        removeMtgCodesRangeFrom: settingItem.removeMtgCodesRangeFrom,
        removeMtgCodesRangeTo: settingItem.removeMtgCodesRangeTo,
        loadUnpaidsAutomatically: settingItem.loadUnpaidsAutomatically,
        addAllUnpaidsToPickList: settingItem.addAllUnpaidsToPickList,
        onlyAdminsCanPostPayments: settingItem.onlyAdminsCanPostPayments,
        abilityToAddMtgCodePayment: settingItem.abilityToAddMtgCodePayment,
        changeBussDateIndividually: settingItem.changeBussDateIndividually,
        autoSelectWkstOnPaymentReports: settingItem.autoSelectWkstOnPaymentReports,
        decalNumberWhenDoingPayments: settingItem.decalNumberWhenDoingPayments,
        restrictWorkstationOverrideToTaxAdminsOnly: settingItem.restrictWorkstationOverrideToTaxAdminsOnly,
        auditsMustBeApprovedBeforePosting: settingItem.auditsMustBeApprovedBeforePosting,
        highlightCheckPaymentsWithNoImage: settingItem.highlightCheckPaymentsWithNoImage,
        latestPostDate: settingItem.latestPostDate,
        noPriorTax: settingItem.noPriorTax,
        allowEditCashTotalOnReconPage: settingItem.allowEditCashTotalOnReconPage,
        preSortEnvelopes: settingItem.preSortEnvelopes,
        defaultPaymentTypeCheck: settingItem.defaultPaymentTypeCheck,
        defaultCursorToParcelID: settingItem.defaultCursorToParcelID,
        receiptReportPrint: settingItem.receiptReportPrint,
        excludeWkst: settingItem.excludeWkst,
        onlyAdminsCanEditTaxAmount: settingItem.onlyAdminsCanEditTaxAmount,
        showCertNumberOnPaymentScreen: settingItem.showCertNumberOnPaymentScreen,
        showReceiptNumberOnPaymentScreen: settingItem.showReceiptNumberOnPaymentScreen,
        alternateOverpaymentHandling: settingItem.alternateOverpaymentHandling,
        allowChangeDueOnCheckPayments: settingItem.allowChangeDueOnCheckPayments,
        defaultWkstOnCheckRecon: settingItem.defaultWkstOnCheckRecon,
        cannotApproveOwnAudit: settingItem.cannotApproveOwnAudit,
        taxAmountChangesCreateAudit: settingItem.taxAmountChangesCreateAudit,
        printLegalDescription: settingItem.printLegalDescription,
        cashOnlyDepositSlip: settingItem.cashOnlyDepositSlip,
        includeFeeDetails: settingItem.includeFeeDetails,
        sepratePaymentOnSummary: settingItem.sepratePaymentOnSummary,
        bccEmailAddress: settingItem.bccEmailAddress,
        subjectLine: settingItem.subjectLine,
        subjectBody: settingItem.subjectBody,
        webApiAccessId: settingItem.webApiAccessId,
        webApiSecureId: settingItem.webApiSecureId,
        webForteLocationId: settingItem.webForteLocationId,
        posApiAccessId: settingItem.posApiAccessId,
        posApiSecureId: settingItem.posApiSecureId,
        posForteLocationId: settingItem.posForteLocationId,
        ivrForteLocationId: settingItem.ivrForteLocationId,
        creditCardPercentage: settingItem.creditCardPercentage,
        debitCardFee: settingItem.debitCardFee,
        posMerchantId: settingItem.posMerchantId,
        webMerchantId: settingItem.webMerchantId,
        payrixCreditPercentage: settingItem.payrixCreditPercentage,
        payrixDebitPercentage: settingItem.payrixDebitPercentage,
        payrixDebitAmtLimit: settingItem.payrixDebitAmtLimit,
        payrixDebitFeeFlat: settingItem.payrixDebitFeeFlat,
        payrixEcheckFee: settingItem.payrixEcheckFee,
        jQueryCdnUrl: settingItem.jQueryCdnUrl,
        payrixCdnUrl: settingItem.payrixCdnUrl,
        payrixBaseUrl: settingItem.payrixBaseUrl,
        payrixPublicKey: settingItem.payrixPublicKey,
        payrixPrivateKey: settingItem.payrixPrivateKey,
        payrixPosEntityId: settingItem.payrixPosEntityId,
        payrixWebEntityId: settingItem.payrixWebEntityId,
        forte2ApiLoginId: settingItem.forte2ApiLoginId,
        forte2CdnUrl: settingItem.forte2CdnUrl,
        forte2CreditPercentage: settingItem.forte2CreditPercentage,
        forte2DebitPercentage: settingItem.forte2DebitPercentage,
        forte2EcheckFee: settingItem.forte2EcheckFee,
        autoMarkCreditCardsAsPaid: settingItem.autoMarkCreditCardsAsPaid,
        paymentDiagnostics: settingItem.paymentDiagnostics === true,
        baseUrlForSMS: settingItem.baseUrlForSMS,
        countyNameForSMS: settingItem.countyNameForSMS,
      };
    },
    async update() {
      if (window.confirm('Are you sure want to update this configuration?')) {
        const payload = {
          calledScope: 'paymentConfig',
          item: this.buildPaymentConfigItem(),
          previousItem: this.originalPaymentSetting,
          isLogAudit: true,
        };
        const ok = await this.updateConfig(payload);
        if (ok) {
          this.originalPaymentSetting = cloneItem(this.buildPaymentConfigItem());
        }
      }
    },
    selectedWkstList(val) {
      this.editItem.excludeWkst = val;
    },
  },
};
</script>
